import React, { Component } from "react";
import { Switch, Route } from "react-router-dom";
import Button from "../../../shared/components/Button/Button";
import Backicon from "../../../shared/components/Backicon/Backicon";
import insurancestyles from "./insuranceregister.module.css";

import InsuranceProfile from "../InsuranceProfile/InsuranceProfile";
import PatientsRecord from "../PatientsRecord/PatientsRecord";
import ComplaintsAndMails from "../ComplaintsAndMails/ComplaintsAndMails";
import PatientsExpense from "../PatientsExpense/PatientsExpense";

const initialState = {
  Name: "",
  Email: "",
  Address: "",
  Password: "",
  NameError: "",
  EmailError: "",
  AddressError: "",
  PasswordError: "",
  isLogin: true,
};
class InsuranceRegister extends Component {
  state = initialState;

  change = (e) => {
    this.setState({
      [e.target.name]: e.target.value,
    });
  };

  validate = () => {
    let NameError = "";
    let EmailError = "";
    let AddressError = "";
    let PasswordError = "";
    //Name Error
    if (!this.state.Name) {
      NameError = "Invalid Name";
    }

    //Email Error
    if (!this.state.Email.includes("@")) {
      EmailError = "Invalid Email";
    }
    //Address Error
    if (!this.state.Address) {
      AddressError = "Address Cannot Be Empty";
    }
    // Password Error
    if (this.state.Password.length < 8) {
      PasswordError = "Need a strong Password";
    }

    if (EmailError || NameError || AddressError || PasswordError) {
      this.setState({ EmailError, NameError, AddressError, PasswordError });
      return false;
    }
    return true;
  };

  onSubmit = (e) => {
    e.preventDefault();
    const isValid = this.validate();
    if (isValid) {
      console.log(this.state);
      const insurance_register = {
        Name: this.state.Name,
        Email: this.state.Email,
        Address: this.state.Address,
        Password: this.state.Password,
      };
      localStorage.setItem(
        "insurance_login_signup",
        JSON.stringify(insurance_register)
      );
      //clear form
      this.setState(initialState);
    }
    this.props.history.push("/insurance/insurance-profile");
  };

  render() {
    return (
      <>
        <div className={insurancestyles.content}>
          <div className={insurancestyles.pregbanner}>
            <Backicon
              onClick={() => this.props.history.goBack()}
              style={{
                background:
                  "linear-gradient(60deg, rgba(2, 12, 29, 0.644) 0%, rgba(67, 184, 192, 0.548) 98%)",
                color: "white",
              }}
            />
            <h1>
              Insurance <br /> register
            </h1>
          </div>
          <div className={insurancestyles.signInStyles}>
            <div>
              <div className={insurancestyles.regbuttons}>
                <button onClick={() => this.setState({ isLogin: true })}>
                  Login
                </button>
                <button onClick={() => this.setState({ isLogin: false })}>
                  Sign Up{" "}
                </button>
              </div>
              <form className={insurancestyles.signupbtn}>
                {!this.state.isLogin && (
                  <>
                    <input
                      name="Name"
                      placeholder={"Name"}
                      value={this.state.name}
                      onChange={(e) => this.change(e)}
                    />
                    {this.state.NameError ? (
                      <div className={insurancestyles.error}>
                        {this.state.NameError}
                      </div>
                    ) : null}
                    <br />
                  </>
                )}

                <input
                  name="Email"
                  placeholder="Email"
                  value={this.state.Email}
                  onChange={(e) => this.change(e)}
                />
                {this.state.EmailError ? (
                  <div className={insurancestyles.error}>
                    {this.state.EmailError}
                  </div>
                ) : null}
                <br />

                {!this.state.isLogin && (
                  <>
                    <textarea
                      name="Address"
                      placeholder="Address"
                      value={this.state.Address}
                      onChange={(e) => this.change(e)}
                    />
                    {this.state.AddressError ? (
                      <div className={insurancestyles.error}>
                        {this.state.AddressError}
                      </div>
                    ) : null}
                    <br />
                  </>
                )}

                <input
                  name="Password"
                  type="password"
                  placeholder="Password"
                  value={this.state.Password}
                  onChange={(e) => this.change(e)}
                />
                {this.state.PasswordError ? (
                  <div className={insurancestyles.error}>
                    {this.state.PasswordError}
                  </div>
                ) : null}
                <div className={insurancestyles.submitButton}>
                  <Button
                    onClick={(e) => this.onSubmit(e)}
                    buttonName={this.state.isLogin ? "Log in" : "sign up"}
                    style={{
                      color: "white",
                      width: "260px",
                      margin: "20px 30px",
                    }}
                  ></Button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </>
    );
  }
}

function InsuranceRoutes() {
  return (
    <Switch>
      <Route path="/insurance" exact component={InsuranceRegister} />
      <Route
        path="/insurance/insurance-profile"
        exact
        component={InsuranceProfile}
      />
      <Route path="/insurance/patientsrecord" component={PatientsRecord} />
      <Route
        path="/insurance/complaintsandmails"
        component={ComplaintsAndMails}
      />
      <Route path="/insurance/patientsexpense" component={PatientsExpense} />
    </Switch>
  );
}

export default InsuranceRoutes;
